"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../../common/helpers/time");
var states_1 = require("../../../../common/constants/states");
var AdminStudentEditController = /** @class */ (function () {
    function AdminStudentEditController($state, $stateParams, UsersModel, FlashService, PoliciesModel) {
        var _this = this;
        this.initialLoad = true;
        this.$state = $state;
        this.states = states_1.States;
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.PoliciesModel = PoliciesModel;
        this.submitted = false;
        this.student = {
            id: 0,
            parent: {
                number: "",
                issuedate: "",
                expirationdate: "",
            },
            usermeta: {
                dob: "",
                start_date: "",
                formatted_drive_deadline: "",
                receives_last_minute_text_reminders: "",
                guardian: {
                    firstname: "",
                    lastname: "",
                    reminders: {
                        receives_last_minute_text_reminders: "",
                    },
                },
                formatted_permit_expiration_date: "",
                formatted_permit_issue_date: "",
                permit: {
                    issuedate: "",
                    expirationdate: "",
                    number: "",
                },
            },
            school: {
                address: {
                    street: "",
                    city: "",
                    state: "",
                    zip: "",
                },
            },
        };
        this.editPassword = false;
        this.stateRequiresPermit = false;
        this.preferred_pronoun_enabled = false;
        PoliciesModel.getByID("studentmetadata").then(function (response) {
            var policyMeta = {};
            response.policy.policymeta.forEach(function (meta) {
                policyMeta[meta.meta_key] = meta.meta_value;
            });
            if (policyMeta.preferred_pronoun) {
                _this.preferred_pronoun_enabled = true;
            }
        });
        UsersModel.getStudentByID($stateParams.userId).then(function (response) {
            response.usermeta.start_date = (0, time_1.formatYmdForDisplay)(response.usermeta.start_date);
            response.usermeta.dob = (0, time_1.formatYmdForDisplay)(response.usermeta.dob);
            _this.student = __assign(__assign({}, response), { parent: {} });
            _this.stateRequiresPermit =
                _this.student.school.address.state === "GA" ||
                    _this.student.school.address.state === "CA" ||
                    _this.student.school.address.state === "PA" ||
                    _this.student.school.address.state === "MO" ||
                    _this.student.school.address.state === "KY" ||
                    _this.student.school.address.state === "NY" ||
                    _this.student.school.address.state === "AZ";
            _this.initialLoad = false;
        });
    }
    AdminStudentEditController.prototype.getStudentAge = function () {
        if (typeof this.student.usermeta.dob === "undefined") {
            return 100;
        }
        var dob = (0, time_1.parseMMDDYYYYDate)(this.student.usermeta.dob);
        return Math.floor((0, time_1.differenceInDays)(new Date(), dob) / 365);
    };
    AdminStudentEditController.prototype.updateStudent = function () {
        var _this = this;
        this.submitted = true;
        var request = Object.assign({}, this.student);
        for (var key in request.usermeta) {
            var value = request.usermeta[key];
            if (value === null || value === "") {
                delete request.usermeta[key];
            }
        }
        // Remove home_address if all fields are empty
        var usermeta = request.usermeta;
        if (usermeta.home_address) {
            var addr = usermeta.home_address;
            if (!addr.street && !addr.city && !addr.state && !addr.zip) {
                delete usermeta.home_address;
            }
        }
        if (request.usermeta.hasOwnProperty("permit")) {
            delete request.usermeta.formatted_permit_expiration_date;
            delete request.usermeta.formatted_permit_issue_date;
            delete request.usermeta.permit;
        }
        delete request.usermeta.formatted_drive_deadline;
        var formattedStartDate = (0, time_1.formatDisplayForYmd)(request.usermeta.start_date);
        if (formattedStartDate) {
            request.usermeta.start_date = formattedStartDate;
        }
        else {
            delete request.usermeta.start_date;
        }
        var formattedDob = (0, time_1.formatDisplayForYmd)(request.usermeta.dob);
        if (formattedDob) {
            request.usermeta.dob = formattedDob;
        }
        else {
            delete request.usermeta.dob;
        }
        request.usermeta.receives_last_minute_text_reminders = "N";
        if (request.usermeta.hasOwnProperty("guardian")) {
            if (!request.usermeta.guardian.hasOwnProperty("reminders")) {
                request.usermeta.guardian.reminders = {
                    receives_last_minute_text_reminders: "N",
                };
            }
            else {
                request.usermeta.guardian.reminders.receives_last_minute_text_reminders =
                    "N";
            }
        }
        this.UsersModel.updateStudent(request)
            .then(function (response) {
            _this.submitted = false;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.$state.go("drivecoach.admin.students.view", {
                userId: _this.student.id,
            }, { reload: true });
        })
            .catch(function (error) {
            _this.submitted = false;
        });
    };
    return AdminStudentEditController;
}());
AdminStudentEditController.$inject = [
    "$state",
    "$stateParams",
    "UsersModel",
    "FlashService",
    "PoliciesModel",
];
exports.default = AdminStudentEditController;
